import { useTranslation } from 'react-i18next';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';
import { canGeneratePassword, generatePassword } from '../../utils/password';

// Vygeneruje silné heslo (spĺňa pravidlá formulára) a odovzdá ho cez onGenerate.
// Do schránky sa zámerne nekopíruje – admin si ho skopíruje sám z políčka.
const PasswordGenerateButton = ({ onGenerate }) => {
  const [t] = useTranslation('global');
  const { showNotification } = useNotification();

  if (!canGeneratePassword()) return null;   // bez bezpečného zdroja náhody tlačidlo neukazujeme

  const handleClick = () => {
    onGenerate(generatePassword());
    showNotification({ message: t('passwordGenerated'), type: NotificationType.Success });
  };

  return (
    <button type="button" className="pwd-generate-btn" onClick={handleClick}>
      <span className="material-symbols-outlined" aria-hidden="true">key</span>
      {t('generatePassword')}
    </button>
  );
};

export default PasswordGenerateButton;
